import { Component, OnInit } from '@angular/core';
import { MenuComponent } from '../menu/menu.component';
import { ContenidoService } from '../contenido.service';

@Component({
  selector: 'app-travel-prepatation',
  templateUrl: './travel-prepatation.component.html',
  styleUrls: [
    '../../assets/css/bootstrap.min.css',
    '../../assets/scss/styles.scss', 
    '../../assets/scss/general-tp.scss', 
    '../../assets/scss/fonts.scss',
    './travel-prepatation.component.css',
    '../../assets/ema/main.scss',
    ]
})
export class TravelPrepatationComponent implements OnInit {
  public contenido = this.contenidoService.getContenido("travel-prepatation");
  constructor(private contenidoService: ContenidoService) { }

  ngOnInit() {
  }

}
